// extracted by mini-css-extract-plugin
export default {"text":"WordsCount_text__EGV7j","wrapper":"WordsCount_wrapper__kxfvW","input":"WordsCount_input__fI0kN"};